import React, { memo } from 'react';
import { bool, func, node, oneOf, oneOfType, string } from 'prop-types';
import { Modal } from 'react-bootstrap';
import Scrollbars from 'react-custom-scrollbars';

import IconClose from '@assets/Icon/svg/Close';
import { noop } from '@ajaibid/utils';
import { Row, Col, Typography } from '@ajaibid/components';
import { Button } from 'Component/Ajaib';

import { styModal, styModalInner } from './style';

const PopUpCenterV2 = (props) => {
  const {
    align,
    backdrop,
    children,
    className,
    closeButton,
    containerClassName,
    onHide,
    keyboard,
    scrollable,
    show,
    size,
    title,
    titleType,
    titleShadow,
    width,
    ...rest
  } = props;

  return (
    <Modal
      centered
      show={show}
      dialogClassName={`${styModal({ width })} ${className}`}
      onHide={onHide}
      backdrop={backdrop}
      keyboard={keyboard}
      size={size}
      {...rest}
    >
      <div
        className={`${styModalInner({ align })} ${containerClassName}`}
        data-testid="divPopUpContainer"
      >
        {title && (
          <Row noGutters align="between">
            <Col size="auto">
              <Typography type="section" bold style={{ margin: 0 }} data-testid="txtTitle">
                {title}
              </Typography>
            </Col>
            {closeButton && (
              <Col size="auto">
                <Button
                  variant="icon"
                  style={{ height: 42 }}
                  onClick={onHide}
                  data-testid="btnClose"
                >
                  <IconClose />
                </Button>
              </Col>
            )}
          </Row>
        )}
        {scrollable ? (
          <div style={{ height: 500 }}>
            <Scrollbars>{children}</Scrollbars>
          </div>
        ) : (
          <div>{children}</div>
        )}
      </div>
    </Modal>
  );
};

PopUpCenterV2.propTypes = {
  align: oneOf(['left', 'center', 'right']),
  backdrop: bool,
  children: oneOfType([node, string]),
  className: string,
  closeButton: bool,
  containerClassName: string,
  onHide: func,
  keyboard: bool,
  scrollable: bool,
  show: bool,
  size: string,
  title: string,
  titleType: string,
  titleShadow: bool,
  width: string,
};

PopUpCenterV2.defaultProps = {
  align: 'center',
  backdrop: true,
  children: null,
  className: '',
  closeButton: true,
  containerClassName: '',
  onHide: noop,
  keyboard: true,
  scrollable: false,
  show: false,
  size: 'lg',
  title: '',
  titleType: 'subtitle',
  titleShadow: false,
  width: '',
};

export default memo(PopUpCenterV2);
